import React from 'react';
import videojs from 'video.js';

import './videoJsStyles.css';

export default class VideoPlayer extends React.Component {

  componentDidMount() {
    window.addEventListener("openVideoDialog", (event) => this.handleOpen(event.data));

    
    // instantiate video.js
    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {});
    this.player.changeSrc = true;
  }

  // destroy player on unmount
  componentWillUnmount() {
    window.removeEventListener("openVideoDialog", () => {});

    if (this.player) {
      this.player.dispose();
    }
  }

  handleOpen(data) {
    this.player.src({type: data.type, src: data.src});
    this.player.load();
    this.player.play();
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    return (
        <>
          <link
            href="https://unpkg.com/@videojs/themes@1/dist/forest/index.css"
            rel="stylesheet"
          />
          <div id="vjs-player-div" data-vjs-player style={{ height: "100%", width: "100%", overflow: "hidden" }}>
              <video ref={node => (this.videoNode = node)} className='video-js vjs-theme-forest' playsInline style={{ height: "100%", width: "100%", overflow: "hidden"}} />
          </div>
        </>
    );
  }
}
